<div class="popup-overlay">
    <div class="popup-content">
      <h3>Confirmation</h3>
      <p>Souhaitez-vous continuer vos achats ou aller au panier ?</p>
      <div class="popup-actions">
        <button (click)="onContinue()">Continuer vos achats</button>
        <button (click)="onGoToCart()">Aller au panier</button>
      </div>
    </div>
  </div>